import { useRegisterShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/registry.js';
import { openSettings } from '#pplx/frontend/apps/ask/settings/settingsHash.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useCallback } from 'react';
/**
 * Registers the **All Settings** global shortcut:
 *   - macOS: Cmd+Shift+,
 *   - Windows/Linux: Ctrl+Shift+,
 *
 * Keybinding, label, and group are resolved from the shortcut manifest.
 */
export function useAllSettingsShortcut() {
    const router = useRouter();
    const handler = useCallback(() => {
        openSettings(router);
    }, [router]);
    useRegisterShortcut({ id: 'all-settings', handler });
}
//# sourceMappingURL=useAllSettingsShortcut.js.map